export default "__VITE_ASSET__CgNktOIa__"